import {
  appointmentTenantsRef,
  applicationsRef,
  clone
} from "@/firebase.js";
import { uuid } from 'vue-uuid'
import moment from 'moment'

export default {
  state: {
    allTenants: [],
    appointmentTenants: [],
    currentAppointmentID: null
  },
  mutations: {
    setAllTenants (state, allTenants) {
      state.allTenants = allTenants;
    },
    setCurrentAppointmentID (state, appointmentID) {
      state.currentAppointmentID = appointmentID;
    }
  },
  actions: {
    async loadAllTenants ({ commit }) {
      appointmentTenantsRef.onSnapshot(querySnapshot => {
        let tenantList = [];
        querySnapshot.forEach(tenant => {
          tenantList.push({id: tenant.id, ...tenant.data()});
        });
        commit("setAllTenants", tenantList);
      });

    },
    async setCurrentAppointmentID ({ commit }, appointmentID) {
      commit("setCurrentAppointmentID", appointmentID);
    },
    async createApplication({ commit, dispatch, rootState }, tenant) {
      // Only create an application when a tenant doesn't have one
      if (!tenant.applicationID) {
        try {
          let _tenant = clone(tenant);
          let application = {
            appStatus: 'Open',
            createdBy: rootState.users.userData.PersonID,
            dateCreated: new Date(),
            linkExpiry: moment().add(2, 'w').toDate(),
            nonAdultTenants: 0,
            adultTenants: 1,
            propertyID: rootState.appointments.selectedAppointment.PropertyID,
            applicants: [
              {
                personID: Number(tenant.PersonID),
                applicantID: uuid.v1(),
                givenNames: _tenant.Name,
                surname: _tenant.LastName,
                email: _tenant.Email,
                homePhone: _tenant.Phone,
                isHeadTenant: true,
                flagID: Number(tenant.Flag),
                lastUpdated: new Date()
              }
            ]
          }
          let newApplication = await applicationsRef.add(application);
          _tenant.applicationID = newApplication.id;
          await appointmentTenantsRef.doc(tenant.id).update(_tenant);
        } catch (ex) {
          console.log("Error creating application: " + ex.message);
        }
      }
    },
    async removeTenant({ commit }, tenant) {
      try {
        await appointmentTenantsRef.doc(tenant.id).delete();
      } catch (ex) {
        console.log('Error removing tenant: ' + ex.message);
      }
    },
    async saveTenant ({ commit }, tenant) {
      try {
        let _tenant = clone(tenant);
        delete _tenant.id;
        if (!_tenant.Flag) {
          _tenant.Flag = 3
        } else {
          _tenant.Flag = Number(_tenant.Flag)
        }
        if (tenant.id) {
          await appointmentTenantsRef.doc(tenant.id).update(_tenant);
          if (_tenant.applicationID && _tenant.applicationID !== 'new') {
            let application = await applicationsRef.doc(_tenant.applicationID).get()
            let applicants = application.data().applicants;
            let names = _tenant.Name.split(' ');
            applicants[0].givenNames = names[0];
            applicants[0].surname = names[1] || '';
            applicants[0].email = _tenant.Email;
            applicants[0].homePhone = _tenant.Phone;
            applicants[0].flagID = Number(_tenant.Flag);
            return applicationsRef.doc(_tenant.applicationID).update({
              applicants: applicants
            });
          }
        } else {
          _tenant.createdInFirestore = true;
          await appointmentTenantsRef.add(_tenant);
        }
      } catch (ex) {
        console.log("Save error: " + ex.message);
      }

    }
  },
  getters: {
    appointmentTenants (state) {
      let _tenantList = [];
      state.allTenants.forEach(t => {
        if (t.AppointmentID == state.currentAppointmentID) {
          _tenantList.push(t);
        }
      });
      return _tenantList;
      // return state.appointmentTenants;
    },
    allTenants (state) {
      return state.allTenants;
    }
  }
};
